"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unavailableInCountryText = void 0;
var shopifyCart = __importStar(require("@shopify/theme-cart"));
var classnames_1 = __importDefault(require("classnames"));
var currency_js_1 = __importDefault(require("currency.js"));
var Cookies = __importStar(require("js-cookie"));
var debounce_1 = __importDefault(require("lodash/debounce"));
var React = __importStar(require("react"));
var react_1 = require("react");
var react_query_1 = require("react-query");
var ga4_utils_1 = require("../../misc/ga4-utils");
var modal_1 = __importDefault(require("../../plugins/modal"));
var fetch_user_geolocation_1 = require("../../utils/fetch-user-geolocation");
var format_price_1 = __importDefault(require("../../utils/format-price/"));
var unavailable_regions_1 = require("../../utils/unavailable-regions");
var money_with_currency_badge_1 = require("../shared-components/money-with-currency-badge");
var bundle_cart_item_1 = __importDefault(require("./bundle-cart-item"));
var calculate_cart_total_price_1 = __importDefault(require("./calculate-cart-total-price"));
var group_items_1 = __importDefault(require("./group-items"));
var paypal_express_checkout_1 = __importDefault(require("./paypal-express-checkout"));
var single_cart_item_1 = __importDefault(require("./single-cart-item"));
var upsells_area_1 = __importDefault(require("./upsells-area"));
var validate_cart_1 = __importDefault(require("./validate-cart"));
exports.unavailableInCountryText = 'This product is unavailable outside of the US.';
/**
 * @param userCountryCode e.g. "US" or "CA"
 */
var tagAndCountryCodeRestrictProduct = function (unavailableRegions, userCountryCode) {
    var e_1, _a;
    try {
        for (var unavailableRegions_1 = __values(unavailableRegions), unavailableRegions_1_1 = unavailableRegions_1.next(); !unavailableRegions_1_1.done; unavailableRegions_1_1 = unavailableRegions_1.next()) {
            var region = unavailableRegions_1_1.value;
            if (userCountryCode === region.countryCode && !region.provinceCode)
                return true;
            // can add a check for an unavailable provinceCode here when needed
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (unavailableRegions_1_1 && !unavailableRegions_1_1.done && (_a = unavailableRegions_1.return)) _a.call(unavailableRegions_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return false;
};
var determineProductUnavailableInCountryProperties = function (userGeolocationQuery, items) {
    var e_2, _a;
    var _b;
    var displayItems = [];
    var cartHasAtLeastOneProductUnavailableInUserCountry;
    if (!userGeolocationQuery.isLoading) {
        cartHasAtLeastOneProductUnavailableInUserCountry = false;
        try {
            for (var items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
                var item = items_1_1.value;
                var unavailableRegions = (0, unavailable_regions_1.getUnavailableRegionsFromCartLineProperties)(item.item.properties || {});
                // Inspect the top-level item. We don't worry about inspecting its children because the bundlers are smart enough to not let
                // the user put products that cannot ship to them in the cart.
                if (unavailableRegions && tagAndCountryCodeRestrictProduct(unavailableRegions, (_b = userGeolocationQuery.data) === null || _b === void 0 ? void 0 : _b.countryCode)) {
                    displayItems.push(__assign(__assign({}, item), { item: __assign(__assign({}, item.item), { showUnavailableInCountryWarning: true }) }));
                    cartHasAtLeastOneProductUnavailableInUserCountry = true;
                }
                else {
                    displayItems.push(__assign(__assign({}, item), { item: __assign(__assign({}, item.item), { showUnavailableInCountryWarning: false }) }));
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
    else {
        displayItems = items;
    }
    return { displayItems: displayItems, cartHasAtLeastOneProductUnavailableInUserCountry: cartHasAtLeastOneProductUnavailableInUserCountry };
};
var isGiftOrderAttributeKey = 'is_gift_order';
var giftRecipientNameAttributeKey = 'gift_recipient_name';
var giftRecipientEmailAttributeKey = 'gift_recipient_email';
var giftMessageAttributeKey = 'gift_message';
var Cart = function (props) {
    var _a = __read((0, react_1.useState)(window.cart), 2), cart = _a[0], setCart = _a[1];
    var userGeolocationQuery = (0, react_query_1.useQuery)([fetch_user_geolocation_1.getOrFetchAndUpdateCountryCodeByIpCookieUseQueryKey], fetch_user_geolocation_1.getOrFetchAndUpdateCountryCodeByIpCookie);
    // Since cart is popped up using Foundation Drawer, we need a way to trigger a state change, especially when activating an AB Test
    var _b = __read((0, react_1.useState)(false), 2), _isStateChangeForced = _b[0], forceStateChange = _b[1];
    var _c = __read((0, react_1.useState)(), 2), validationErrors = _c[0], setValidationErrors = _c[1];
    // used to make sure the checkout button is disabled while upsell products are being added
    var _d = __read((0, react_1.useState)(false), 2), isAddingProduct = _d[0], setIsAddingProduct = _d[1];
    // state values for giftable orders
    var _e = __read((0, react_1.useState)(cart.attributes[isGiftOrderAttributeKey] === '1' ? '1' : undefined), 2), isGiftOrder = _e[0], setIsGiftOrder = _e[1]; // string-only
    var _f = __read((0, react_1.useState)(cart.attributes[giftRecipientNameAttributeKey]), 2), giftRecipientName = _f[0], setGiftRecipientName = _f[1];
    var _g = __read((0, react_1.useState)(cart.attributes[giftRecipientEmailAttributeKey]), 2), giftRecipientEmail = _g[0], setGiftRecipientEmail = _g[1];
    var _h = __read((0, react_1.useState)(cart.attributes[giftMessageAttributeKey]), 2), giftMessage = _h[0], setGiftMessage = _h[1];
    var lowerAttentiveZIndex = function () {
        var element = document === null || document === void 0 ? void 0 : document.getElementById('attentive_overlay');
        if (element) {
            element.style.zIndex = '999';
        }
    };
    var triggerForceStateChange = function () {
        forceStateChange(!_isStateChangeForced);
    };
    (0, react_1.useEffect)(function () {
        window.cartApp = { add: addToCart, clear: clearCart };
        // Since cart is popped up using Foundation Drawer, we need a way to trigger a state change, especially when activating an AB Test
        document.body.addEventListener('customCheckoutActivated', triggerForceStateChange);
        document.body.addEventListener('cartUpsellsActivated', triggerForceStateChange);
    }, []);
    (0, react_1.useEffect)(function () { return renderExternalDOM((0, group_items_1.default)(cart.items)); }, [cart.items]);
    (0, react_1.useEffect)(lowerAttentiveZIndex);
    var addToCart = function (itemsToAdd, opts) {
        if (opts === void 0) { opts = {
            redirectToCheckout: false,
        }; }
        return __awaiter(void 0, void 0, void 0, function () {
            var freshCart, cartValidationErrors, res, body, fresherCart;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getCart()];
                    case 1:
                        freshCart = _a.sent();
                        lowerAttentiveZIndex();
                        cartValidationErrors = (0, validate_cart_1.default)(freshCart.items, itemsToAdd);
                        if (cartValidationErrors.length) {
                            markCartInvalid(cartValidationErrors);
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, fetch('/cart/add.js', {
                                body: JSON.stringify({
                                    items: itemsToAdd.map(function (_a) {
                                        var _b = __read(_a, 2), variantId = _b[0], properties = _b[1];
                                        return (__assign({ id: variantId }, properties));
                                    }),
                                }),
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                method: 'POST',
                            })];
                    case 2:
                        res = _a.sent();
                        if (!!res.ok) return [3 /*break*/, 4];
                        return [4 /*yield*/, res.json()];
                    case 3:
                        body = _a.sent();
                        console.error(body);
                        alert("".concat(body.message, " - ").concat(body.description) || 'There was an error.');
                        return [2 /*return*/, false];
                    case 4: return [4 /*yield*/, getCart()];
                    case 5:
                        fresherCart = _a.sent();
                        dlPublishAddToCart(itemsToAdd, fresherCart);
                        if (!opts.redirectToCheckout) return [3 /*break*/, 7];
                        return [4 /*yield*/, redirectToCheckout()];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        window.Drawer.open('cart-drawer');
                        _a.label = 8;
                    case 8: return [2 /*return*/, true];
                }
            });
        });
    };
    var dlPublishAddToCart = function (itemsToAdd, localCart) {
        var _a, _b;
        try {
            var productData = itemsToAdd.map(function (item) {
                var _a;
                var variantFromCart = localCart.items.find(function (i) { return i.variant_id === item[0]; });
                return {
                    id: item[0],
                    name: variantFromCart === null || variantFromCart === void 0 ? void 0 : variantFromCart.product_title,
                    variant: variantFromCart === null || variantFromCart === void 0 ? void 0 : variantFromCart.variant_title,
                    quantity: (_a = item[1]) === null || _a === void 0 ? void 0 : _a.quantity,
                    price: (variantFromCart === null || variantFromCart === void 0 ? void 0 : variantFromCart.price) ? (variantFromCart.price / 100).toFixed(2) : '0',
                    sku: variantFromCart === null || variantFromCart === void 0 ? void 0 : variantFromCart.sku,
                };
            });
            (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({
                event: 'addToCart',
                ecommerce: {
                    currencyCode: 'USD',
                    add: {
                        products: productData,
                    },
                },
            });
            try {
                var items_2 = productData.map(function (item) { return ({
                    product: { title: item.name || '' },
                    title: item.variant || '',
                    sku: item.sku || '',
                    price: Number(item.price),
                    quantity: item.quantity || 1,
                }); });
                dlPublishAddToCartEcommerce(items_2);
            }
            catch (err) {
                console.error('Failed to publish ecommerce add_to_cart event to DL', err);
            }
            (_b = window.dataLayer) === null || _b === void 0 ? void 0 : _b.push({ event: 'optimize.addToCartTriggered' });
        }
        catch (err) {
            console.error("Failed to publish add to cart event to DL", err);
        }
    };
    var dlPublishAddToCartEcommerce = function (items) {
        var priceSumCurrency = items.reduce(function (sumCurrency, item) {
            var priceCurrency = (0, currency_js_1.default)(item.price).multiply(item.quantity || 1);
            return sumCurrency.add(priceCurrency);
        }, (0, currency_js_1.default)(0));
        (0, ga4_utils_1.emitAddToCartGa4Event)(items, priceSumCurrency.value, window.currency);
    };
    var clearCart = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch('/cart/clear.js', {
                        method: 'POST',
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var closeCartDrawer = function () {
        if (props.onClose) {
            props.onClose();
        }
    };
    var getCart = function () { return __awaiter(void 0, void 0, void 0, function () {
        var contents;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, shopifyCart.getState()];
                case 1:
                    contents = _a.sent();
                    setCart(function () { return contents; });
                    return [2 /*return*/, contents];
            }
        });
    }); };
    var handleRemoveFromCartClick = function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var keys;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    keys = [item.item.key];
                    if (item.children) {
                        item.children.forEach(function (child) { return keys.push(child.key); });
                    }
                    return [4 /*yield*/, removeFromCart(keys)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var markCartInvalid = function (validationMessages) {
        var _a;
        setValidationErrors(validationMessages);
        (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({
            event: 'cartValidationError',
            errors: validationMessages,
        });
    };
    var cartHasSubscriptionItem = function () { return cart.items.some(function (item) { var _a; return !!((_a = item.properties) === null || _a === void 0 ? void 0 : _a.subscription_id); }); };
    var redirectToCheckout = function () { return __awaiter(void 0, void 0, void 0, function () {
        var cartValidationErrors;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getCart()];
                case 1:
                    _a.sent();
                    cartValidationErrors = (0, validate_cart_1.default)(cart.items, []);
                    if (!!cartValidationErrors.length)
                        markCartInvalid(cartValidationErrors);
                    if (!canContinueToCheckout)
                        return [2 /*return*/];
                    window.location.href = (function () {
                        // TODO: move as much logic from var.get-checkout-url.liquid into here
                        if (usingCustomCheckout)
                            return '/pages/checkout';
                        if (window.cartSettings.useShopifyCheckoutForALaCarte && !cartHasSubscriptionItem())
                            return '/checkout';
                        return window.getCheckoutUrl(process.env.PERMANENT_DOMAIN);
                    })();
                    return [2 /*return*/];
            }
        });
    }); };
    var removeFromCart = function (keys) { return __awaiter(void 0, void 0, void 0, function () {
        var updates, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    updates = cart.items.map(function (item) { return (keys.includes(item.key) ? 0 : item.quantity); });
                    return [4 /*yield*/, updateCart(updates)];
                case 1:
                    _a.sent();
                    return [2 /*return*/, true];
                case 2:
                    e_3 = _a.sent();
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var renderExternalDOM = function (cartItems) {
        var numItems = cartItems.reduce(function (sum, item) { return sum + item.item.quantity; }, 0);
        var innerHTML = numItems > 0 ? "".concat(numItems) : '';
        var display = numItems > 0 ? 'flex' : 'none';
        Array.from(document.querySelectorAll('[data-cart-count]')).forEach(function (el) {
            el.innerHTML = innerHTML;
            el.style.display = display;
        });
    };
    // @shopify/theme-cart doesn't include a mass update function
    // https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#update-cart
    var updateCart = function (updates) { return __awaiter(void 0, void 0, void 0, function () {
        var res, json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch('/cart/update.js', {
                        body: JSON.stringify({ updates: updates }),
                        headers: { 'Content-Type': 'application/json' },
                        method: 'POST',
                    })];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    json = _a.sent();
                    setCart(function () { return json; });
                    return [2 /*return*/, json];
            }
        });
    }); };
    var handleDecreaseQuantityClick = function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var updates;
        return __generator(this, function (_a) {
            updates = cart.items.map(function (_a) {
                var id = _a.id, quantity = _a.quantity;
                return (id === item.item.id ? quantity - 1 : quantity);
            });
            updateCart(updates);
            return [2 /*return*/];
        });
    }); };
    var handleIncreaseQuantityClick = function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var validationParams, cartValidationErrors, updates, ecommerceItem;
        return __generator(this, function (_a) {
            validationParams = cart.items.map(function (cartItem) {
                if (cartItem.variant_id === item.item.id) {
                    return __assign(__assign({}, cartItem), { quantity: cartItem.quantity + 1 });
                }
                else
                    return cartItem;
            });
            cartValidationErrors = (0, validate_cart_1.default)(validationParams, []);
            if (cartValidationErrors.length) {
                markCartInvalid(cartValidationErrors);
            }
            else {
                updates = cart.items.map(function (_a) {
                    var id = _a.id, quantity = _a.quantity;
                    return (id === item.item.id ? quantity + 1 : quantity);
                });
                updateCart(updates);
                try {
                    ecommerceItem = __assign(__assign({}, item.item), { product: { title: item.item.product_title }, title: item.item.variant_title, sku: item.item.sku || '', price: (0, currency_js_1.default)(item.item.price, { fromCents: true }).value, 
                        // item.item.quantity is the old quantity in the cart, but we intend to tell GTM the *change* in cart items that occurred rather
                        // than the new or old quantity already in the cart, so we use 1 since this function always increases quantity by exactly 1.
                        quantity: 1 });
                    dlPublishAddToCartEcommerce([ecommerceItem]);
                }
                catch (err) {
                    console.error('Failed to publish ecommerce add_to_cart event to DL', err);
                }
            }
            return [2 /*return*/];
        });
    }); };
    var updateCartAttributes = function (attributes) {
        return fetch('/cart/update.js', {
            body: JSON.stringify({ attributes: attributes }),
            headers: {
                'Content-Type': 'application/json',
            },
            method: 'POST',
        });
    };
    var toggleGiftableCart = function () { return __awaiter(void 0, void 0, void 0, function () {
        var newValue;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    newValue = isGiftOrder ? undefined : '1';
                    return [4 /*yield*/, updateCartAttributes((_a = {}, _a[isGiftOrderAttributeKey] = newValue || '', _a))
                        // update the state, and clear the name and email always
                    ];
                case 1:
                    _b.sent();
                    // update the state, and clear the name and email always
                    setIsGiftOrder(newValue);
                    setGiftRecipientName(undefined);
                    setGiftRecipientEmail(undefined);
                    setGiftMessage(undefined);
                    return [2 /*return*/];
            }
        });
    }); };
    var onGiftableFieldChange = function (attributeKey) {
        return (0, debounce_1.default)(function (e) { return __awaiter(void 0, void 0, void 0, function () {
            var newValue;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        newValue = e.target.value;
                        if (attributeKey === giftRecipientNameAttributeKey)
                            setGiftRecipientName(newValue);
                        else if (attributeKey === giftMessageAttributeKey)
                            setGiftMessage(newValue);
                        else
                            setGiftRecipientEmail(newValue);
                        return [4 /*yield*/, updateCartAttributes((_a = {}, _a[attributeKey] = newValue, _a))];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); }, 300);
    };
    var embedded = props.embedded, hideCloseButton = props.hideCloseButton, expanded = props.expanded;
    // Set up cart items for display.
    var items = (0, group_items_1.default)(cart.items);
    var _j = determineProductUnavailableInCountryProperties(userGeolocationQuery, items), displayItems = _j.displayItems, cartHasAtLeastOneProductUnavailableInUserCountry = _j.cartHasAtLeastOneProductUnavailableInUserCountry;
    var canContinueToCheckout = (0, react_1.useMemo)(function () {
        if (!items.length)
            return false;
        if (isAddingProduct)
            return false;
        // If the cart has a restricted item, don't allow checkout. The "most correct" thing to do here would be to also check if cartHasAtLeastOneProductUnavailableInUserCountry
        // is undefined, meaning that it hasn't yet been determined if the cart contains restricted items, but the chances of the cart containing restricted items
        // is very low, and blocking checkout should be done with much care.
        if (cartHasAtLeastOneProductUnavailableInUserCountry)
            return false;
        if (isGiftOrder && (!giftRecipientEmail || !giftRecipientName || !giftMessage))
            return false;
        return true;
    }, [items, isAddingProduct, cartHasAtLeastOneProductUnavailableInUserCountry, isGiftOrder, giftRecipientEmail, giftRecipientName, giftMessage]);
    var upsellsAreaTitle = items.length > 0 ? 'You may also like:' : 'You may like:';
    var usingCustomCheckout = !!window.cartSettings.forceCustomCheckout || !!Cookies.get('abCustomCheckout');
    var shouldShowPaypal = !!window.cartSettings.isPaypalEnabled && !!window.cartSettings.paymentAuth && usingCustomCheckout;
    var cartContainsUngiftableItem = (0, react_1.useMemo)(function () {
        return cart.items.some(function (item) {
            if (!item.properties)
                return false; // this shouldn't happen, but typescript gon' type
            if ('bundle_id' in item.properties)
                return true; // this is a bundle
            if ('giftCardRecipientEmail' in item.properties)
                return true; // this is a gift card
            if (item.vendor !== 'Hello Bello')
                return true; // this is fulfilled by some other service
        });
    }, [cart.items]);
    return (React.createElement("div", { className: (0, classnames_1.default)({ 'bordered border-very-light-pink bg-white height-100': !embedded, emdedded: embedded }), style: { overflow: 'scroll' } },
        React.createElement(modal_1.default, { isOpen: !!(validationErrors === null || validationErrors === void 0 ? void 0 : validationErrors.length), handleClose: function () { return setValidationErrors(undefined); } },
            React.createElement("div", { className: 'padding-4 padding-bottom-9 text-center', style: { maxWidth: 480 } },
                React.createElement("h5", { className: 'h5 margin-bottom-2' }, "Oops!"),
                React.createElement("div", { dangerouslySetInnerHTML: { __html: window.cartSettings.cartValidationErrorMessage || '' } }),
                React.createElement("button", { className: 'margin-top-4 button btn-form', onClick: function () { return setValidationErrors(undefined); } }, "Continue"))),
        !embedded && (React.createElement("div", { className: 'cart-drawer__header bg-white text-center padding-vertical-4 bordered-bottom border-very-light-pink' },
            !hideCloseButton && (React.createElement("div", { className: 'left-section' },
                React.createElement("button", { "data-close-drawer": 'cart-drawer', onClick: closeCartDrawer },
                    React.createElement("img", { src: window.cartSettings.closeImageUrl })))),
            React.createElement("div", { className: 'middle-section bold' }, "Your Bag"),
            React.createElement("div", { className: 'right-section' }))),
        React.createElement("div", { className: (0, classnames_1.default)('cart-drawer__content', { 'padding-bottom-40 overflow-y-auto': !embedded }) },
            React.createElement("div", { className: 'padding-horizontal-4 padding-top-1' }, !items.length ? (React.createElement("div", { className: 'text-center height-100 flex-container align-center align-middle' },
                React.createElement("div", null,
                    React.createElement("img", { className: 'display-block padding-horizontal-4 large-padding-horizontal-10', src: window.cartSettings.empty_image, style: { width: '100%', objectFit: 'contain', height: '150px' } }),
                    React.createElement("div", { className: 'margin-bottom-0 font-bold h4 padding-horizontal-10 margin-top-6' }, window.cartSettings.empty_text)))) : (displayItems.map(function (item) {
                return (React.createElement("div", { key: item.item.key },
                    !!item.children && (React.createElement(bundle_cart_item_1.default, { item: item, removeFromCart: handleRemoveFromCartClick, expanded: !!Cookies.get('abExpandBundleInCart') || !!expanded, allowActions: !embedded })),
                    !item.children && (React.createElement(single_cart_item_1.default, { item: item, allowActions: !embedded, increaseQuantity: handleIncreaseQuantityClick, decreaseQuantity: handleDecreaseQuantityClick, removeFromCart: handleRemoveFromCartClick }))));
            }))),
            window.cartSettings.areGiftableOrdersEnabled && !cartContainsUngiftableItem && items.length ? (React.createElement("div", { className: 'padding-4' },
                React.createElement("label", null,
                    React.createElement("input", { type: 'checkbox', checked: !!isGiftOrder, onChange: function () { return toggleGiftableCart(); } }),
                    "This order is a gift"),
                isGiftOrder ? (React.createElement("div", null,
                    React.createElement("div", { className: 'font-bold margin-bottom-1' }, "Recipient Information"),
                    React.createElement("div", { className: 'margin-bottom-2' },
                        React.createElement("input", { type: 'text', className: 'margin-bottom-0', placeholder: 'Full Name', onChange: function (e) {
                                e.persist();
                                onGiftableFieldChange(giftRecipientNameAttributeKey)(e);
                            }, defaultValue: giftRecipientName })),
                    React.createElement("div", { className: 'margin-bottom-2' },
                        React.createElement("input", { type: 'email', className: 'margin-bottom-0', pattern: '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$', placeholder: 'Email Address', onChange: function (e) {
                                e.persist();
                                onGiftableFieldChange(giftRecipientEmailAttributeKey)(e);
                            }, defaultValue: giftRecipientEmail })),
                    React.createElement("div", { className: 'margin-bottom-2' },
                        React.createElement("div", { className: 'text-warm-grey' }, "Gift Message"),
                        React.createElement("textarea", { onChange: function (e) {
                                e.persist();
                                onGiftableFieldChange(giftMessageAttributeKey)(e);
                            }, defaultValue: giftMessage })))) : null)) : null,
            !embedded && React.createElement(upsells_area_1.default, { title: upsellsAreaTitle, cartItems: items, setIsAddingProduct: setIsAddingProduct, cartSettings: window.cartSettings })),
        !embedded && (React.createElement("div", { className: 'cart-drawer__affix-bottom' },
            React.createElement("div", { className: 'cart-drawer__checkout-container' },
                React.createElement("div", { className: 'font-size-14 font-bold flex-container justify-between' },
                    React.createElement("div", { className: 'flex-container items-center', style: { paddingTop: 3 } }, "Subtotal"),
                    React.createElement(money_with_currency_badge_1.MoneyWithCurrencyBadge, { currency: 'USD', className: 'width-50 flex-container items-center justify-end' },
                        React.createElement("span", null, (0, format_price_1.default)((0, calculate_cart_total_price_1.default)(items))))),
                cartHasAtLeastOneProductUnavailableInUserCountry ? (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: 'margin-top-2' }),
                    React.createElement("div", { className: 'flex-container justify-center items-center' },
                        React.createElement("img", { className: 'w-4', src: window.cartSettings.exclamationTriangleIconURL, alt: 'Exclamation triangle icon' }),
                        React.createElement("div", { className: 'margin-left-1' }),
                        React.createElement("div", { style: { marginTop: 3 } }, "Remove Restricted Items")))) : (
                // Spacer for when there is no "Remove Restricted Items" text taking up space
                React.createElement("div", { className: 'margin-top-4' })),
                shouldShowPaypal && !!items.length && React.createElement(paypal_express_checkout_1.default, { items: cart.items }),
                React.createElement("div", null,
                    React.createElement("a", { className: (0, classnames_1.default)('button btn-form', !canContinueToCheckout && 'disabled'), onClick: redirectToCheckout }, isAddingProduct ? (React.createElement("span", null,
                        "Adding...",
                        React.createElement("span", { className: 'padding-left-3' },
                            React.createElement("img", { style: { width: '1em', height: '1em' }, src: window.cartSettings.spinnerBlack })))) : ('Checkout'))))))));
};
exports.default = Cart;
